"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetValueParamsByDisplayNameId = exports.useGetValueIdsByRegDeviceId = exports.useGetValueByRegDeviceId = exports.useGetValueById = exports.useGetUntTranslate = exports.useGetDeviceValues = exports.useGetDeviceValueByParams = void 0;
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _selectors = require("../redux/selectors");
var _constants = require("../utils/constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useGetDeviceValueByParams = _ref => {
  let {
    thingPDIDDevice,
    displayNameId
  } = _ref;
  return (0, _reactRedux.useSelector)((0, _selectors.selectDeviceValueByParams)(thingPDIDDevice, displayNameId)) || {};
};
exports.useGetDeviceValueByParams = useGetDeviceValueByParams;
const useGetDeviceValues = _ref2 => {
  let {
    thingPDIDDevice = null
  } = _ref2;
  const values = (0, _reactRedux.useSelector)(_selectors.selectValuesById)[thingPDIDDevice] || {};
  return (0, _react.useMemo)(() => values || {}, [values]);
};
exports.useGetDeviceValues = useGetDeviceValues;
const useGetValueById = _ref3 => {
  let {
    displayNameId,
    thingPDIDDevice
  } = _ref3;
  const values = useGetDeviceValues({
    thingPDIDDevice
  });
  const value = values[displayNameId] || {};
  return (0, _react.useMemo)(() => value, [value]);
};
exports.useGetValueById = useGetValueById;
const useGetValueByRegDeviceId = _ref4 => {
  let {
    thingPDIDDevice = null,
    regular
  } = _ref4;
  const {
    displayNameId = []
  } = (0, _reactRedux.useSelector)(_selectors.selectDevicesById)[thingPDIDDevice] || {};
  const values = useGetDeviceValues({
    thingPDIDDevice
  });
  const valueKey = (0, _react.useMemo)(() => displayNameId.find(key => regular === null || regular === void 0 ? void 0 : regular.test(key)) || {}, [displayNameId, regular]);
  return (0, _react.useMemo)(() => values[valueKey] || {}, [values[valueKey]]);
};
exports.useGetValueByRegDeviceId = useGetValueByRegDeviceId;
const useGetUntTranslate = _ref5 => {
  var _activeTranslations$D2;
  let {
    unit
  } = _ref5;
  const activeTranslations = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsValues);
  return (0, _react.useMemo)(() => {
    var _activeTranslations$D;
    return (activeTranslations === null || activeTranslations === void 0 || (_activeTranslations$D = activeTranslations.Default) === null || _activeTranslations$D === void 0 ? void 0 : _activeTranslations$D.unit[unit]) || '';
  }, [activeTranslations === null || activeTranslations === void 0 || (_activeTranslations$D2 = activeTranslations.Default) === null || _activeTranslations$D2 === void 0 ? void 0 : _activeTranslations$D2.unit, unit]);
};
exports.useGetUntTranslate = useGetUntTranslate;
const useGetValueParamsByDisplayNameId = _ref6 => {
  let {
    thingPDIDDevice = null,
    displayNameId,
    params = []
  } = _ref6;
  const valueObj = useGetDeviceValueByParams({
    thingPDIDDevice,
    displayNameId
  });
  const list = params.map(param => param === _constants.valueParamsName.value ? _paulCorePackage.functions.parseByValueType(valueObj[param], valueObj.valueType) : valueObj[param]);
  return (0, _react.useMemo)(() => list, [list]);
};
exports.useGetValueParamsByDisplayNameId = useGetValueParamsByDisplayNameId;
const useGetValueIdsByRegDeviceId = _ref7 => {
  let {
    thingPDIDDevice = null,
    regular
  } = _ref7;
  const {
    displayNameId = []
  } = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.selectDevicesById)[thingPDIDDevice] || {};
  const valueKeys = (0, _react.useMemo)(() => displayNameId.filter(key => regular === null || regular === void 0 ? void 0 : regular.test(key)) || {}, [displayNameId, regular]);
  return (0, _react.useMemo)(() => valueKeys, [valueKeys]);
};
exports.useGetValueIdsByRegDeviceId = useGetValueIdsByRegDeviceId;